import { createAsyncThunk, current } from '@reduxjs/toolkit';
import axios from 'axios';
import { axiosAdmin } from '../../../utils/axiosUser';

export const initStateCommentSingle = {
  commentSingle: { data: null, loading: false, error: null },
};

export const commentSingle = createAsyncThunk('user/commentSingle', async (data, { rejectWithValue, fulfillWithValue }) => {
  return await axiosAdmin
    .get(`/comment/${data.id}`, {
      params: data,
    })
    .then((res) => {
      return fulfillWithValue(res.data);
    })
    .catch((res) => {
      return rejectWithValue(res.response.data);
    });
});

export const reducerCommentSingle = {
  [commentSingle.pending]: (state) => {
    state.commentSingle.loading = true;
  },
  [commentSingle.fulfilled]: (state, action) => {
    state.commentSingle.loading = false;
    state.commentSingle.data = action.payload;
    state.commentSingle.error = null;
  },
  [commentSingle.rejected]: (state, action) => {
    state.commentSingle.data = null;
    state.commentSingle.loading = false;
    state.commentSingle.error = action.payload;
  },
};
